// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__+PFmV"};